<template>
  <div class="images_upload_components">
    <div class="image_upload_item" v-for="(item, index) in imageList" :key='item'>
      <div class="image">
        <img :src="item" @click="_previewImage(index)">
      </div>
      <div class="image_del" @click="_removeImage(index, item)">
        <i class='hzjcicon hzjcicon-ai54'></i>
      </div>
    </div>
    <div class="image_upload_item image_upload" @click="_chooseImage()" v-if="imageList.length < imageCount">
      <div class="image"></div>
    </div>
  </div>
</template>

<script>
import '../styles/iconfont/iconfont.css'
import wx from '../../../wx'
export default {
  name: 'ImagesUpload',
  props: {
    imageList: {
      type: Array,
      default: () => []
    },
    product_index:{
      type: Number
    },
    imageCount: { // todo 限制>=1且<=9
      type: Number,
      default: 5
    },
    sizeType: {
      type: Array,
      default: () => ['original', 'compressed']
    },
    sourceType: {
      type: Array,
      default: () => ['album', 'camera']
    }
  },
  methods: {
    // 选择图片
    _chooseImage (e) {
      let that = this
      var imageList = this.imageList
      var imageCount = this.imageCount
      var imageLength = imageList.length || 0
      var count = parseInt(imageCount) - imageLength

      let obj = {
        count: count,
        sizeType: this.sizeType,
        sourceType: this.sourceType
      }
      wx.chooseImage(obj).then(res => {
        that.$emit('upload', {
          product_index:this.product_index,
          uploadImageList: res
        })
      })
    },
    // 移除图片
    _removeImage (index, item) {
      this.$emit('delete', {
        product_index:this.product_index,
        index: index,
        imageUrl: item
      })
    },
    // 预览图片
    _previewImage: function (index) {
      let that = this
      let obj = {
        url: that.imageList[index],
        urls: that.imageList
      }
      wx.previewImage(obj)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .images_upload_components
    width 100%
    position relative
    background #fff
    font-size 32px
    padding 10px 0
    align-items center
    overflow hidden
    .image_upload_item
      position relative
      float left
      width 25%
      padding 5px
      box-sizing border-box
      .image
        width 150px
        height 150px
        background #fff
        margin 0 auto
        img
          display block
          width 100%
          height 100%
      .image_del
        margin 0
        padding 0
        height 20px
        width 20px
        position absolute
        top -8px
        right 8px
        text-align center
        .hzjcicon
          float left
          color rgba(0, 0, 0, 0.6)
          font-size 32px !important
    .image_upload
      .image
        box-sizing border-box
        border 1px solid #d9d9d9
      .image:before,.image:after
        content " "
        position absolute
        top 50%
        left 50%
        -webkit-transform translate(-50%, -50%)
        transform translate(-50%, -50%)
        background-color #d9d9d9
      .image:before
        width 2px
        height 40px
      .image:after
        width 40px
        height 2px
</style>



// WEBPACK FOOTER //
// src/components/hzjc/images-upload/Index.vue